import { faArrowUpFromBracket } from "@fortawesome/free-solid-svg-icons/faArrowUpFromBracket"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, useTheme } from "@mallardbay/lib-react-components"
import React from "react"

import COPY from "~config/copy-constants"
import { useCopyOrShare } from "~utils/use-copy-or-share"

export default function ShareOutfitterButton() {
    const { colors } = useTheme()
    const copyOrShare = useCopyOrShare()
    const styleProps = useStyleProps()
    return (
        <Button
            variant="ghost"
            onClick={copyOrShare}
            leftIcon={
                <FontAwesomeIcon
                    icon={faArrowUpFromBracket}
                    color={colors.brandDefault}
                />
            }
            {...styleProps.baseButton}
        >
            {COPY.SHARE.SHARE}
        </Button>
    )
}

function useStyleProps() {
    const baseButton = {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        borderRadius: "full",
    }

    return { baseButton }
}
